'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TiFeather = function TiFeather(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm19.5 1.7l-0.3-0.1-0.3 0.1c-8.1 1.5-13.9 8.5-13.9 16.6 0 7.7 5.2 14.4 12.5 16.4v2c0 0.9 0.7 1.6 1.7 1.6s1.6-0.7 1.6-1.6v-2c7.4-2 12.5-8.7 12.5-16.4 0-8.1-5.8-15.1-13.8-16.6z m1.3 29.5v-19.5c0-1-0.7-1.7-1.6-1.7s-1.7 0.7-1.7 1.7v19.5c-5.3-1.9-9-6.8-9.2-12.5l5.3 5.2c0.1 0.2 0.4 0.3 0.6 0.3s0.4-0.1 0.6-0.3c0.3-0.3 0.3-0.8 0-1.2l-6.3-6.2c0.2-1.6 0.7-3.2 1.4-4.6l3.7 3.7c0.1 0.2 0.4 0.2 0.6 0.2s0.4 0 0.6-0.2c0.3-0.3 0.3-0.9 0-1.2l-4-3.9c2-2.7 4.9-4.8 8.4-5.5 3.4 0.7 6.4 2.8 8.3 5.5l-3.9 3.9c-0.4 0.3-0.4 0.9 0 1.2 0.1 0.2 0.4 0.2 0.6 0.2s0.4 0 0.6-0.2l3.6-3.7c0.7 1.4 1.2 3 1.5 4.6l-6.3 6.2c-0.4 0.4-0.4 0.9 0 1.2 0.1 0.2 0.4 0.3 0.6 0.3s0.4-0.1 0.6-0.3l5.2-5.2c-0.2 5.7-3.9 10.6-9.2 12.5z' })
        )
    );
};

exports.default = TiFeather;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/ti/feather.js
// module id = 2054
// module chunks = 0